<svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
>
    <path
    d="M5.13119 1.43197C4.96715 1.59606 4.875 1.81858 4.875 2.05059C4.875 2.28261 4.96715 2.50513 5.13119 2.66922L9.46244 7.00047L5.13119 11.3317C4.9718 11.4967 4.8836 11.7178 4.8856 11.9472C4.88759 12.1766 4.97961 12.3961 5.14185 12.5583C5.30408 12.7205 5.52354 12.8126 5.75296 12.8146C5.98238 12.8166 6.20341 12.7284 6.36844 12.569L11.3183 7.61909C11.4823 7.45501 11.5745 7.23249 11.5745 7.00047C11.5745 6.76845 11.4823 6.54593 11.3183 6.38184L6.36844 1.43197C6.20435 1.26793 5.98183 1.17578 5.74981 1.17578C5.51779 1.17578 5.29527 1.26793 5.13119 1.43197Z"
    fill="white"
    />
</svg>

<style>
    svg {
        margin-left: 10px;
    }
</style>